import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '../context/AuthContext';
import { ChevronLeft } from 'lucide-react';

/**
 * TODOS LOS AVISOS (artefacto «Mi semana», pantalla del mismo nombre).
 *
 *     «Los hitos que le pueden salir. Ninguno riñe, y todos llevan la salida al lado.»
 *     «Los quince que le pueden salir, en tres grupos: la semana, el ciclo y lo que falta.
 *      Cada uno con su día a la derecha y su botón debajo. El de la fecha límite es el
 *      único marcado, porque es el único que tiene consecuencia si se pasa.»
 *
 * No es la campana: la campana enseña lo que le toca HOY. Esto es lo que le puede llegar a
 * lo largo de su ciclo, para que sepa a qué atenerse.
 */
const TodosLosAvisosPage = () => {
    const navigate = useNavigate();
    const { api } = useAuth();
    const [cargando, setCargando] = useState(true);
    const [avisos, setAvisos] = useState([]);
    const [grupos, setGrupos] = useState([]);

    useEffect(() => {
        let vivo = true;
        (async () => {
            try {
                const { data } = await api.get('/notifications/catalogo');
                if (!vivo) return;
                setAvisos(data.avisos || []);
                setGrupos(data.grupos || []);
            } catch {
                if (vivo) toast.error('No pudimos traer tus avisos');
            } finally {
                if (vivo) setCargando(false);
            }
        })();
        return () => { vivo = false; };
    }, [api]);

    if (cargando) {
        return (
            <div className="min-h-[60vh] flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-4 border-brand border-t-transparent" />
            </div>
        );
    }

    return (
        <div className="max-w-xl mx-auto px-4 lg:px-0 pb-28" data-testid="todos-los-avisos">
            <button type="button" onClick={() => navigate('/dashboard/semana')}
                className="flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground mb-3">
                <ChevronLeft className="w-4 h-4" /> Mi semana
            </button>

            <h1 className="titulo-pantalla">TODOS LOS AVISOS</h1>

            {grupos.map(g => {
                const suyos = avisos.filter(a => a.grupo === g.id);
                if (!suyos.length) return null;
                return (
                    <div key={g.id} className="mt-5" data-testid={`catalogo-${g.id}`}>
                        <p className="caption mb-2">{g.titulo}</p>
                        <div className="space-y-2">
                            {suyos.map((a, i) => (
                                /* EL ÚNICO MARCADO es el de la fecha límite, y lleva el color
                                   de la casa en el borde, no en el texto: la riña sería el
                                   texto, y ese está escrito sin ella. */
                                <div key={`${g.id}-${i}`}
                                    data-testid={a.marcado ? 'aviso-marcado' : undefined}
                                    className={`surface p-3.5 ${
                                        a.marcado ? 'border border-brand/45 bg-brand/[0.06]' : ''}`}>
                                    <div className="flex items-start justify-between gap-3">
                                        <p className="text-sm font-bold text-foreground min-w-0">{a.titulo}</p>
                                    </div>
                                    {a.detalle && (
                                        <p className="text-xs text-muted-foreground mt-1">{a.detalle}</p>
                                    )}
                                    {a.accion && a.link && (
                                        <button type="button" onClick={() => navigate(a.link)}
                                            className="mt-2 rounded-lg border border-brand/50 text-brand text-xs font-bold px-3 py-1.5 hover:bg-brand/10 transition-colors">
                                            {a.accion}
                                        </button>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                );
            })}
            {/* Sin «se pueden apagar en Mi perfil» (17-10): la tarjeta de avisos se quitó. */}
        </div>
    );
};

export default TodosLosAvisosPage;
